import {environment} from "src/environments/environment";
import {DTOAdvertisementImage} from "../api/WickedApiClient";

export class FileInfo extends DTOAdvertisementImage {
  size: number;
  file: File;
  progressPercentage: number = 0;
  loaded: number = 0;
  isUploading: boolean = false;
  uploaded: boolean = true;
  imageUrl: string;

  init(data?: any) {
    super.init(data);
    if(data) {
      this.imageUrl = `${environment.apiBaseUrl}/FileGet/${this.fileName}`;
    }
  }

  static fromJS(data: any): FileInfo {
    data = typeof data === "object" ? data : {};
    let result = new FileInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    super.toJSON(data);
    return data;
  }
}

export interface UploadFileInfo {
  name: string;
  fileName: string;
  localFilename: string;
  size: number;
  isImage: boolean;
  isTemp: boolean;
}

export interface UploadResponse {
  files: UploadFileInfo[];
}
export interface UploadBanerResponse {
  files: UploadFileInfo[];
  isBanerSize: boolean;
}
